import { render, staticRenderFns } from "./PhoneBrands.vue?vue&type=template&id=61b0ad53&scoped=true&"
import script from "./PhoneBrands.vue?vue&type=script&lang=js&"
export * from "./PhoneBrands.vue?vue&type=script&lang=js&"
import style0 from "./PhoneBrands.vue?vue&type=style&index=0&id=61b0ad53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0ad53",
  null
  
)

component.options.__file = "PhoneBrands.vue"
export default component.exports